import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LegalTemplateOption } from '../legalTemplateOption';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';

export enum LegalUrlType {
  TermsAndConditions,
  PrivacyPolicy,
}
@Injectable()
export class LegalsService {
  private apiBaseUrl = environment.apiBaseUrl;
  legalTemplateOptionList$: BehaviorSubject<Array<LegalTemplateOption>> = new BehaviorSubject<
    Array<LegalTemplateOption>
  >([]);
  hasToSubmitLegalOptions$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  GetLegalUrl(urlType: LegalUrlType, currentLang: string): string {
    let urlBase;
    switch (urlType) {
      case LegalUrlType.TermsAndConditions:
        urlBase = ThemeConfig.termsAndCondition;
        break;
      case LegalUrlType.PrivacyPolicy:
        urlBase = ThemeConfig.privacyPolicy;
        break;
    }
    return urlBase.replace('?l=it', `?l=${currentLang}`);
  }

  getLegalTemplateOption(lang): Observable<LegalTemplateOption[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/public/v1/auth/legalTemplateOption?lang=' + lang)
      .pipe(
        map((response) => {
          if (response) {
            const legalTemplateOptionList: LegalTemplateOption[] =
              response as LegalTemplateOption[];
            this.legalTemplateOptionList$.next(legalTemplateOptionList);
            return legalTemplateOptionList;
          }
        })
      );
  }

  getLegalTemplateOptionNoNext(lang): Observable<LegalTemplateOption[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/public/v1/auth/legalTemplateOption?lang=' + lang)
      .pipe(
        map((response) => {
          if (response) {
            const legalTemplateOptionList: LegalTemplateOption[] =
              response as LegalTemplateOption[];
            return legalTemplateOptionList;
          }
        })
      );
  }

  // checks if the user has still to submit legal options
  checkLegalOptionFromUser = (
    legalTemplateOptionList: Array<LegalTemplateOption>,
    userLegal
  ): boolean => {
    let incompatibleCount = 0;
    if (
      legalTemplateOptionList &&
      legalTemplateOptionList.length > 0 &&
      ((userLegal && userLegal.length === 0) || !userLegal)
    ) {
      this.hasToSubmitLegalOptions$.next(true);
      return true;
    } else {
      if (
        legalTemplateOptionList &&
        legalTemplateOptionList.length > 0 &&
        userLegal &&
        userLegal.length > 0
      ) {
        legalTemplateOptionList.forEach((legalTemplateOptionItem) => {
          const resultCheck = userLegal.filter(
            (item) => item.legalTemplateOption === legalTemplateOptionItem.id
          );
          if (resultCheck.length === 0) {
            incompatibleCount++;
          } else if (
            resultCheck.length > 0 &&
            legalTemplateOptionItem.required &&
            !resultCheck[0].value
          ) {
            incompatibleCount++;
          }
        });
      } else {
        this.hasToSubmitLegalOptions$.next(false);
        return false;
      }
    }

    this.hasToSubmitLegalOptions$.next(incompatibleCount > 0);
    return incompatibleCount > 0;
  };
}
